<template>
  <div v-if="overallValues">
    <div style="margin:0px 4px;" class="incfont">
      <table class="tbl-table">
        <thead class="tbl-th">
          <tr class="tbl-tr" v-bind:class="{ 'tbl-bg': coloredHeader }">
            <td class="tbl-td tbl-cell" v-bind:style="{ width: getHeadWidth + '%' }"></td>
            <td class="tbl-td tbl-cell bold"
                v-bind:class="{ head15 : waveCount < 5, head10 : waveCount > 4, narrow: isCompetitionOverall }"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getHead(index) }}</td>
          </tr>
        </thead>
        <tbody v-if="!isBmwMoto">
          <tr class="tbl-tr" v-if="hasValues('NumberOfShopsPureOnline')">
            <td class="tbl-td tbl-cell left scenario-header">{{$t('Webportal.DashboardBMW.PureOnline')}}</td>
            <td class="tbl-td tbl-cell"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getValue(index, 'NumberOfShopsPureOnline') }}</td>
          </tr>
          <tr class="tbl-tr" v-if="hasValues('NumberOfShopsOnlineIntegrated')">
            <td class="tbl-td tbl-cell left scenario-header">{{$t('Webportal.DashboardBMW.OnlineIntegrated')}}</td>
            <td class="tbl-td tbl-cell"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getValue(index, 'NumberOfShopsOnlineIntegrated') }}</td>
          </tr>
          <tr class="tbl-tr" v-if="hasValues('NumberOfShopsPureTelephone')">
            <td class="tbl-td tbl-cell left scenario-header">{{$t('Webportal.DashboardBMW.PureTelephone')}}</td>
            <td class="tbl-td tbl-cell"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getValue(index, 'NumberOfShopsPureTelephone') }}</td>
          </tr>
          <tr class="tbl-tr" v-if="hasValues('NumberOfShopsTelephoneIntegrated')">
            <td class="tbl-td tbl-cell left scenario-header">{{$t('Webportal.DashboardBMW.TelephoneIntegrated')}}</td>
            <td class="tbl-td tbl-cell"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getValue(index, 'NumberOfShopsTelephoneIntegrated') }}</td>
          </tr>
          <tr class="tbl-tr" v-if="hasValues('NumberOfShopsWalkIn')">
            <td class="tbl-td tbl-cell left scenario-header">{{$t('Webportal.DashboardBMW.WalkIn')}}</td>
            <td class="tbl-td tbl-cell"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getValue(index, 'NumberOfShopsWalkIn') }}</td>
          </tr>
          <tr v-if="!isUsedCar2021 && hasValues('NumberOfShops100PercentDigital')" class="tbl-tr">
            <td class="tbl-td tbl-cell left scenario-header">{{$t('Webportal.DashboardBMW.HundretPercentDigital')}}</td>
            <td class="tbl-td tbl-cell"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getValue(index, 'NumberOfShops100PercentDigital') }}</td>
          </tr>
          <tr v-if="!isUsedCar2021 && hasValues('NumberOfShopsPureOnlineOnlineStore')" class="tbl-tr">
            <td class="tbl-td tbl-cell left scenario-header">{{$t('Webportal.DashboardBMW.PureOnlineOnlineStore')}}</td>
            <td class="tbl-td tbl-cell"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getValue(index, 'NumberOfShopsPureOnlineOnlineStore') }}</td>
          </tr>
          <tr class="tbl-tr" v-if="hasValues('NumberOfCallBackWithSubsequentVisit')">
            <td class="tbl-td tbl-cell left scenario-header">{{$t('Webportal.DashboardBMW.CallbackWithSubsequentVisit')}}</td>
            <td class="tbl-td tbl-cell"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getValue(index, 'NumberOfCallBackWithSubsequentVisit') }}</td>
          </tr>
          <tr class="tbl-tr" v-if="hasValues('NumberOfCallBackWithoutSubsequentVisit')">
            <td class="tbl-td tbl-cell left scenario-header">{{$t('Webportal.DashboardBMW.CallbackWithoutSubsequentVisit')}}</td>
            <td class="tbl-td tbl-cell"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getValue(index, 'NumberOfCallBackWithoutSubsequentVisit') }}</td>
          </tr>
        </tbody>
        <tbody v-else>
        </tbody>
        <tfoot>
          <tr class="tbl-tr" v-bind:class="{ 'tbl-bg': coloredHeader }">
            <td class="tbl-td tbl-cell left">{{$t('Webportal.DashboardBMW.Total')}}</td>
            <td class="tbl-td tbl-cell bold"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getValue(index, 'NumberOfShopsTotal') }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ShopsOverall',

    props: {
      overallValues: {type: Object, default: null},
      isCompetitionOverall: {type: Boolean, default: false },
      coloredHeader: {type: Boolean, default: true },
      isBmwMoto: {type: Boolean, default: false },
      isUsedCar2021: {type: Boolean, default: false },
    },

    methods: {
      hasValues(iwot) {
        return !this.overallValues.SurveyWave.map(x => x[iwot]).every(x => x === undefined);
      },

      getValue(wave, iwot) {
        let waveItem = this.getWaveItem(wave)
        if (!waveItem)
          return '-'

        let data = waveItem[iwot];
        return data ? data : '-';
      },

      getWaveItem(index) {
        if (!(_.size(this.overallValues.SurveyWave) > index))
          return undefined

        if (this.isCompetitionOverall) {
          // HACK: Fixes sorting (static)
          if (index === 0) return this.overallValues.SurveyWave[2]
          if (index === 1) return this.overallValues.SurveyWave[0]
          if (index === 2) return this.overallValues.SurveyWave[1]
          if (index === 3) return this.overallValues.SurveyWave[4]
          if (index === 4) return this.overallValues.SurveyWave[3]
        }

        return this.overallValues.SurveyWave[index]
      },

      hasWaves() {
        return this.overallValues && this.overallValues.SurveyWave && _.size(this.overallValues.SurveyWave) > 0
      },

      getHead(index) {
        if (!(_.size(this.overallValues.SurveyWave) > index))
          return ''
        let item = this.overallValues.SurveyWave[index]
        if (!this.isCompetitionOverall) {
          return this.getShortName(item);
        }
        var longName = this.isCompetitionOverall ? item.PropertyValue : item.Name;
        if (!longName.startsWith('2021_')) { return longName; }
        return longName.replace('2021_', '');
      },
      
      getShortName(item) {
        let name = item.Name; 
        if (name.startsWith(item.Year.toString())) 
          name = name.substring(2);
        name = name.replace('_', '');
        return name;
      },

    },

    computed: {
      getHeadWidth: function() {
        let waves = this.waveCount
        if (waves < 5) return 100 - waves * 15
        return 100 - waves * 10
      },

      waveCount: function () {
        if (!this.hasWaves) return 0
        return _.size(this.overallValues.SurveyWave)
      },

      hasOnline: function(){
        if (this.isBmw2021) return true;
        if (!this.hasWaves())
          return false

        let result = false;
        _.forEach(this.overallValues.SurveyWave, function(value) {
          if (value.NumberOfShopsOnline) result = true;
        });
        return result;
      },
      hasIntegrated: function() {
        if (this.isBmw2021) return true;
        if (!this.hasWaves())
          return false

        let result = false;
        _.forEach(this.overallValues.SurveyWave, function(value) {
          if (value.NumberOfShopsOnlineIntegrated) result = true;
        });
        return result;
      },
      hasWalkIn: function() {
        if (this.isBmw2021) return true;
        if (!this.hasWaves())
          return false

        let result = false;
        _.forEach(this.overallValues.SurveyWave, function(value) {
          if (value.NumberOfShopsWalkIn) result = true;
        });
        return result;
      },
      hasTelephoneIntegrated: function() {
        if (this.isBmw2021) return true;
        if (!this.hasWaves())
          return false

        let result = false;
        _.forEach(this.overallValues.SurveyWave, function(value) {
          if (value.NumberOfShopsTelephoneIntegrated) result = true;
        });
        return result;
      },
      hasTelephone: function() {
        if (this.isBmw2021) return true;
        if (!this.hasWaves())
          return false

        let result = false;
        _.forEach(this.overallValues.SurveyWave, function(value) {
          if (value.NumberOfShopsTelephone) result = true;
        });
        return result;
      },

    }
  }
</script>


<style scoped>
td {
  font-size: 9pt;
}
.narrow {
  letter-spacing: -0.15em;
}
.left{
  text-align: left;
}
.bold {
  font-weight: bold;
}
.head10 {
  width:10%;
}
.head40 {
  width:40%;
}
td {
  color:black;
}
.home {
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  background: transparent;
}

.scenario-header {
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
